import React, { Component, ReactElement, ReactNode } from 'react';

import { classNames } from '@philips-emr/tws-utils';

export interface SlideUpPanelHeaderProps {
  children?: ReactNode | ReactNode[];
  className?: string;
  title?: string;
}

class SlideUpPanelHeader extends Component<SlideUpPanelHeaderProps> {

  getClassNames(): string {
    const { className } = this.props;

    return classNames({
      'c-slide-up-panel__header': true,
      [`${className}`]: Boolean(className),
    });
  }

  renderTitle(): ReactNode {
    const { title } = this.props;

    if (!title) {
      return null;
    }

    return <div className="c-slide-up-panel__header__title">{title}</div>;
  }

  render(): ReactElement {
    const { children } = this.props;

    return(
      <div className={this.getClassNames()}>
        {this.renderTitle()}
        {children}
      </div>
    );
  }
}

export default SlideUpPanelHeader;
